import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import { Transaction_Profile } from "../../Connections/Transaction";

import "../../Styles/Chat.css";
import Toast from "../../Utils/Toast";

import Page from "../Page/Page";
import moment from "jalali-moment";

const Chat = (props) => {
  const navigator = useNavigate();

  // ==============================================================

  const chatWrapperRef = useRef(null);

  // ==============================================================

  const [message, setMessage] = useState("");
  const [messageHistory, setMessageHistory] = useState([]);

  // ==============================================================

  const handleSubmitSendMessageForm = (e) => {
    e.preventDefault();
    if (message) {
      const form = new FormData();
      form.append("text", message);
      Transaction_Profile.AddOnlineChat(form)
        .then((res) => {
          if (res[0]) {
            setMessageHistory([
              ...messageHistory,
              {
                id: messageHistory[messageHistory.length - 1].id + 1,
                text: message,
                type: "Send",
                date: `${new Date().toISOString()}`,
                isSeen: false,
              },
            ]);
            Toast("success", "پیام با موفقیت ارسال شد!");
            setMessage("");
          }
        })
        .catch((err) => console.log(err));
    }
  };

  // ==============================================================

  useEffect(() => {
    Transaction_Profile.GetOnlineChats(1, 100)
      .then((res) => {
        if (res[0]) {
          setMessageHistory(res[2].data.items);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    chatWrapperRef.current.scrollTo(0, chatWrapperRef.current.scrollHeight);
  }, [messageHistory]);

  // ==============================================================
  return (
    <Page>
      <MobileNavBar
        text={"گفتگوی آفلاین"}
        action={() => navigator("/profile")}
      />
      <div className="Chat_wrapper">
        <div
          className="Chat_back-arrow mobile-hidden"
          onClick={() => navigator("/profile")}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            />
          </svg>
        </div>
        <div className="Chat_messages-container" ref={chatWrapperRef}>
          {messageHistory.map((item) => (
            <div
              className={`Chat_message-wrapper ${
                item.type != "send" ? "my-message" : ""
              }`}
              key={item.id}
            >
              <p>{item.text}</p>
              {item.type != "send" ? (
                <div className="Chat_message-info">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="12"
                    viewBox="0 0 9 7"
                    fill="none"
                  >
                    {item.isSeen ? (
                      <path
                        d="M8.87236 0.729314C8.99605 0.55614 8.95594 0.31548 8.78277 0.191785C8.60959 0.068089 8.36893 0.108199 8.24524 0.281373L4.39191 5.67604C4.26821 5.84921 4.30832 6.08987 4.48149 6.21357C4.65467 6.33726 4.89533 6.29715 5.01902 6.12398L8.87236 0.729314Z"
                        fill="#ADB5BD"
                      />
                    ) : null}
                    <path
                      d="M7.33103 0.729343C7.45472 0.55617 7.41461 0.31551 7.24144 0.191814C7.06827 0.068119 6.82761 0.108229 6.70391 0.281403L3.13653 5.27573L1.1447 2.95193C1.00621 2.79035 0.762946 2.77164 0.601365 2.91014C0.439785 3.04864 0.421073 3.2919 0.55957 3.45348L2.87157 6.15081C2.94866 6.24075 3.06283 6.29023 3.18116 6.285C3.2995 6.27976 3.40885 6.2204 3.4777 6.12401L7.33103 0.729343Z"
                      fill="#ADB5BD"
                    />
                  </svg>
                  <span>
                    <span style={{ marginRight: "5px" }}>
                      {moment(item.date).locale("fa").format("YYYY/M/D")}
                    </span>
                    <span>
                      {item.date.split("T")[1].split(":")[0] +
                        ":" +
                        item.date.split("T")[1].split(":")[1]}
                    </span>
                  </span>
                </div>
              ) : null}
            </div>
          ))}
        </div>
        <form
          onSubmit={handleSubmitSendMessageForm}
          className="Chat_message-input"
        >
          <textarea
            placeholder="چیزی بنویسید...!"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
          <button type="submit" className="desktop-hidden">
            <img src="/imgs/profile/send-message-btn.svg" alt="" />
          </button>
          <button
            type="submit"
            className="mobile-hidden messages-container-submit-btn"
          >
            <img src="/imgs/profile/send-message-btn.svg" alt="" />
          </button>
        </form>
      </div>
    </Page>
  );
};

export default Chat;
